import { useCallback } from 'react'
import { useNavigate, useParams, Navigate } from 'react-router-dom'
import { message } from 'antd'
import mapValues from 'lodash/mapValues'
import { ListError, PageHeader } from '../Common'
import api from '../../api'
import { toPath } from '../../routes'
import { useAsync } from '../../hooks'
import PreAuthorizationsForm from './Form'
import { toShortDate } from '../../lib/datetime'

export default function NewPreAuthorization() {
  const navigate = useNavigate()
  const { id: cycleId } = useParams()
  const fetchCycle = useCallback(() => api.cycles.get(cycleId), [cycleId])
  const {
    value: cycle,
    error: cycleError,
    clearError: clearCycleError,
  } = useAsync(fetchCycle)

  const onSubmit = useCallback(
    async (
      {
        cptCode,
        icd10Code,
        patientId,
        billingDate,
        authorized,
        medicalProviderId,
        insuranceAuthorizationNumber,
        notes,
      },
      { setErrors },
    ) => {
      try {
        const preAuthorization = await api.preAuthorizations.create(cycleId, {
          cptCode,
          icd_10_code: icd10Code,
          patientId,
          billingDate: toShortDate(billingDate),
          authorized,
          cycle,
          medicalProviderId,
          insuranceAuthorizationNumber,
          notes,
        })
        message.success('Remote authorization successfully created')
        navigate(
          toPath.preAuthorizations.preAuthorization({
            id: preAuthorization.id,
          }),
          { replace: true },
        )
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, fieldErrors => fieldErrors[0]))
        } else {
          message.error(e.message)
        }
      }
    },
    [cycle, cycleId, navigate],
  )

  if (cycleError) {
    message.error(cycleError.message)
    return <Navigate to={toPath.preAuthorizations()} />
  }

  return (
    <div>
      <PageHeader
        title="New Remote Authorization"
        onBack={() => navigate(-1)}
      />
      {cycleError && (
        <ListError description={cycleError.message} onClose={clearCycleError} />
      )}
      {cycle && (
        <PreAuthorizationsForm
          onSubmit={onSubmit}
          practiceId={cycle.practiceId}
          endsAt={cycle?.endsAt}
        />
      )}
    </div>
  )
}
